function Us() {
  return (
    <div
      id="us"
      className="d-flex align-items-center justify-content-center py-5"
    >
      <div className="container">
        <h1>
          Tissy&
          <br />
          Gabriel
        </h1>
        <h2 className="px-2">Eu em você, você em mim, simples assim ❤️</h2>
      </div>
    </div>
  );
}

export default Us;
